import React from "react";

import { placeholderPermissions } from "@/App/constants/permissions";
import Dashboard from "@/App/pages/Dashboard";

interface RouteProps {
  path: string;
  Component: React.FC<{ pageTitle: string }> | React.ComponentClass;
  pageTitle: string;
  label?: string;
  iconClassName?: string;
  inMainMenu: boolean;
  requiredPermissions: Array<string>;
  breadcrumb?: React.FC | string;
  exact?: boolean;
  isActive?: (match: {}, location: { pathname: string }) => boolean;
  redirectTo?: string;
}

export const appRoutes: Array<RouteProps> = [
  {
    path: "/",
    Component: Dashboard,
    pageTitle: "Dashboard",
    label: "Dashboard",
    iconClassName: "caprx-icon-home",
    inMainMenu: true,
    requiredPermissions: placeholderPermissions, // update
    breadcrumb: "Dashboard",
  },
];
